/**
 * Program IDL in camelCase format in order to be used in JS/TS.
 *
 * Note that this is only a type helper and is not the actual IDL. The original
 * IDL can be found at `target/idl/blockasset_project.json`.
 */
export type BlockassetProject = {
  address: "prjzeH8Jr5cbwMbzP8BykkRnW88MQ9pcRbqkvL74ewK";
  metadata: {
    name: "blockassetProject";
    version: "2.4.10";
    spec: "0.1.0";
    description: "Blockasset project";
    repository: "https://github.com/Blockasset/blockasset-labs/tree/main/programs/blockasset-project";
  };
  instructions: [
    {
      name: "adminCloseIdentifier";
      discriminator: [17, 55, 18, 68, 137, 251, 70, 72];
      accounts: [
        {
          name: "identifier";
          writable: true;
        },
        {
          name: "payer";
          writable: true;
          signer: true;
        },
      ];
      args: [];
    },
    {
      name: "adminCloseProject";
      discriminator: [42, 2, 72, 109, 130, 235, 188, 65];
      accounts: [
        {
          name: "project";
          writable: true;
        },
        {
          name: "payer";
          writable: true;
          signer: true;
        },
      ];
      args: [];
    },
    {
      name: "adminInitIdentifier";
      docs: ["admin instructions ///"];
      discriminator: [46, 66, 173, 167, 249, 218, 220, 194];
      accounts: [
        {
          name: "identifier";
          writable: true;
          pda: {
            seeds: [
              {
                kind: "const";
                value: [105, 100, 101, 110, 116, 105, 102, 105, 101, 114];
              },
            ];
          };
        },
        {
          name: "payer";
          writable: true;
          signer: true;
        },
        {
          name: "systemProgram";
          address: "11111111111111111111111111111111";
        },
      ];
      args: [
        {
          name: "ix";
          type: {
            defined: {
              name: "adminInitIdentifierIx";
            };
          };
        },
      ];
    },
    {
      name: "adminUpdateIdentifier";
      discriminator: [133, 105, 49, 201, 225, 98, 73, 9];
      accounts: [
        {
          name: "identifier";
          writable: true;
        },
        {
          name: "payer";
          writable: true;
          signer: true;
        },
        {
          name: "systemProgram";
          address: "11111111111111111111111111111111";
        },
      ];
      args: [
        {
          name: "ix";
          type: {
            defined: {
              name: "adminUpdateIdentifierIx";
            };
          };
        },
      ];
    },
    {
      name: "adminUpdateProject";
      discriminator: [96, 51, 87, 19, 46, 245, 101, 27];
      accounts: [
        {
          name: "project";
          writable: true;
        },
        {
          name: "payer";
          writable: true;
          signer: true;
        },
        {
          name: "systemProgram";
          address: "11111111111111111111111111111111";
        },
      ];
      args: [
        {
          name: "ix";
          type: {
            defined: {
              name: "adminUpdateProjectIx";
            };
          };
        },
      ];
    },
    {
      name: "closeProject";
      discriminator: [117, 209, 53, 106, 93, 55, 112, 49];
      accounts: [
        {
          name: "project";
          writable: true;
        },
        {
          name: "payer";
          writable: true;
          signer: true;
        },
      ];
      args: [];
    },
    {
      name: "initProject";
      discriminator: [40, 78, 156, 122, 54, 85, 204, 46];
      accounts: [
        {
          name: "project";
          writable: true;
          pda: {
            seeds: [
              {
                kind: "const";
                value: [112, 114, 111, 106, 101, 99, 116];
              },
              {
                kind: "account";
                path: "identifier.count";
                account: "identifier";
              },
            ];
          };
        },
        {
          name: "identifier";
          writable: true;
        },
        {
          name: "payer";
          writable: true;
          signer: true;
        },
        {
          name: "systemProgram";
          address: "11111111111111111111111111111111";
        },
      ];
      args: [
        {
          name: "ix";
          type: {
            defined: {
              name: "initProjectIx";
            };
          };
        },
      ];
    },
    {
      name: "updateProject";
      discriminator: [2, 196, 131, 92, 28, 139, 179, 94];
      accounts: [
        {
          name: "project";
          writable: true;
        },
        {
          name: "payer";
          writable: true;
          signer: true;
        },
        {
          name: "systemProgram";
          address: "11111111111111111111111111111111";
        },
      ];
      args: [
        {
          name: "ix";
          type: {
            defined: {
              name: "updateProjectIx";
            };
          };
        },
      ];
    },
  ];
  accounts: [
    {
      name: "identifier";
      discriminator: [204, 189, 217, 160, 27, 67, 108, 181];
    },
    {
      name: "project";
      discriminator: [205, 168, 189, 202, 181, 247, 142, 19];
    },
  ];
  errors: [
    {
      code: 6000;
      name: "invalidProjectAuthority";
      msg: "Invalid project authority";
    },
    {
      code: 6001;
      name: "permissionDenied";
      msg: "Permission denied";
    },
  ];
  types: [
    {
      name: "adminInitIdentifierIx";
      type: {
        kind: "struct";
        fields: [
          {
            name: "defaultStaticFee";
            type: "u64";
          },
          {
            name: "defaultTreasury";
            type: "pubkey";
          },
          {
            name: "defaultSellerFeeBasisPoint";
            type: "u16";
          },
        ];
      };
    },
    {
      name: "adminUpdateIdentifierIx";
      type: {
        kind: "struct";
        fields: [
          {
            name: "defaultStaticFee";
            type: "u64";
          },
          {
            name: "defaultTreasury";
            type: "pubkey";
          },
          {
            name: "defaultSellerFeeBasisPoint";
            type: "u16";
          },
        ];
      };
    },
    {
      name: "adminUpdateProjectIx";
      type: {
        kind: "struct";
        fields: [
          {
            name: "authorities";
            type: {
              vec: "pubkey";
            };
          },
          {
            name: "name";
            type: "string";
          },
          {
            name: "staticFee";
            type: "u64";
          },
          {
            name: "treasury";
            type: "pubkey";
          },
          {
            name: "sellerFeeBasisPoint";
            type: "u16";
          },
          {
            name: "authorizedTokenCreators";
            type: {
              vec: "pubkey";
            };
          },
          {
            name: "public";
            type: "bool";
          },
        ];
      };
    },
    {
      name: "identifier";
      type: {
        kind: "struct";
        fields: [
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "count";
            type: "u64";
          },
          {
            name: "defaultStaticFee";
            type: "u64";
          },
          {
            name: "defaultTreasury";
            type: "pubkey";
          },
          {
            name: "defaultSellerFeeBasisPoint";
            type: "u16";
          },
        ];
      };
    },
    {
      name: "initProjectIx";
      type: {
        kind: "struct";
        fields: [
          {
            name: "authorities";
            type: {
              vec: "pubkey";
            };
          },
          {
            name: "name";
            type: "string";
          },
          {
            name: "authorizedTokenCreators";
            type: {
              vec: "pubkey";
            };
          },
          {
            name: "public";
            type: {
              option: "bool";
            };
          },
        ];
      };
    },
    {
      name: "project";
      type: {
        kind: "struct";
        fields: [
          {
            name: "bump";
            type: "u8";
          },
          {
            name: "identifier";
            type: "u64";
          },
          {
            name: "authorities";
            type: {
              vec: "pubkey";
            };
          },
          {
            name: "staticFee";
            type: "u64";
          },
          {
            name: "treasury";
            type: "pubkey";
          },
          {
            name: "name";
            type: "string";
          },
          {
            name: "public";
            type: "bool";
          },
          {
            name: "sellerFeeBasisPoint";
            type: "u16";
          },
          {
            name: "authorizedTokenCreators";
            type: {
              vec: "pubkey";
            };
          },
        ];
      };
    },
    {
      name: "updateProjectIx";
      type: {
        kind: "struct";
        fields: [
          {
            name: "authorities";
            type: {
              option: {
                vec: "pubkey";
              };
            };
          },
          {
            name: "name";
            type: {
              option: "string";
            };
          },
          {
            name: "authorizedTokenCreators";
            type: {
              option: {
                vec: "pubkey";
              };
            };
          },
          {
            name: "public";
            type: {
              option: "bool";
            };
          },
        ];
      };
    },
  ];
};
